import React from "react";
import { Outlet } from "react-router-dom";
import { RouteProps } from "routes";

import "./About.scss";

export default class About extends React.Component<RouteProps, any> {
  render() {
    return (
      <div className="about">
        <Outlet />
      </div>
    );
  }
}
